<template>
  <div class="header">
    <div class="container">
      <div class="logo forbes">
        <a
          href="https://forbes.hu"
          title="Forbes"
        >
          <img
            src="../assets/img/forbes-head.svg"
            alt="Forbes"
          >
        </a>
      </div>
      <div class="logo vodafone">
        <a
          href="https://vodafone.hu"
          title="Vodafone"
        >
          <img
            src="../assets/img/vodafone-logo.svg"
            alt="Vodafone"
          >
        </a>
      </div>
      <div class="social">
        <a
          href="https://www.facebook.com/sharer/sharer.php?u=https%3A//forbes.hu/extra/a-legbefolyasosabb-magyar-nok-2019/"
          title="Megosztás a Facebookon"
          class="face"
        >
          <img
            src="../assets/img/facebook-icon.svg"
            alt="Facebook"
          >
        </a>
        <a
          href="https://www.instagram.com/forbeshungary/"
          title="Forbes az Instagramon"
          class="insta"
        >
          <img
            src="../assets/img/instagram-icon.svg"
            alt="Instagram"
          >
        </a>
        <a
          href="https://twitter.com/home?status=https%3A//forbes.hu/extra/a-legbefolyasosabb-magyar-nok-2019/"
          title="Megosztás a Twitteren"
          class="twitter"
        >
          <img
            src="../assets/img/twitter-icon.svg"
            alt="Twitter"
          >
        </a>
      </div>
      <div class="mobilemenu">
        <div
          class="opener"
          v-on:click="menu"
        >
          <div class="bars">

          </div>
        </div>
        <div class="socialm">
          <a
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A//forbes.hu/extra/a-legbefolyasosabb-magyar-nok-2019/"
            title="Megosztás a Facebookon"
            class="face"
          >
            <img
              src="../assets/img/facebook-icon.svg"
              alt="Facebook"
            >
          </a>
          <a
            href="https://www.instagram.com/forbeshungary/"
            title="Forbes az Instagramon"
            class="insta"
          >
            <img
              src="../assets/img/instagram-icon.svg"
              alt="Instagram"
            >
          </a>
          <a
            href="https://twitter.com/home?status=https%3A//forbes.hu/extra/a-legbefolyasosabb-magyar-nok-2019/"
            title="Megosztás a Twitteren"
            class="twitter"
          >
            <img
              src="../assets/img/twitter-icon.svg"
              alt="Twitter"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    menu() {
      document.querySelector('.mobilemenu .socialm').classList.toggle('show');
      document.querySelector('.mobilemenu').classList.toggle('open');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: space-between;
}
.logo.forbes img {
  height: 22px;
}
.logo.vodafone img {
  height: 40px;
}
.social img {
  height: 25px;
}
.insta {
  margin: 0 10px;
}
.social a:hover img {
  transform: scale(1.2);
}
.mobilemenu {
  display: none;
}
@media screen and (max-width: 520px) {
  .social {
    display: none;
  }
  .mobilemenu {
    display: block;
  }
  .opener {
    position: relative;
    cursor: pointer;
    height: 35px;
    display: flex;
    align-items: center;
  }
  .bars {
    background-color: #42475c;
    width: 30px;
    height: 3px;
  }
  .bars:before,
  .bars:after {
    content: "";
    height: 3px;
    width: 30px;
    display: block;
    position: absolute;
    background-color: #42475c;
  }
  .bars:before {
    top: 8px;
  }
  .bars:after {
    bottom: 8px;
  }
  .open .bars {
    background-color: transparent;
  }
  .open .bars:before {
    transform: rotate(-45deg) translate(-6px, 4px);
  }
  .open .bars:after {
    transform: rotate(45deg) translate(-7px, -5px);
  }
  .mobilemenu .socialm {
    display: none;
  }
  .mobilemenu .socialm.show {
    display: flex;
    position: absolute;
    top: 65px;
    left: 0px;
    width: calc(100% - 20px);
    background-color: #fff;
    padding: 20px 10px;
    justify-content: center;
    z-index: 2;
  }
  .socialm img {
    height: 25px;
  }
  .socialm a:hover img {
    transform: scale(1.2);
  }
  .insta {
    margin: 0 30px;
  }
}
</style>
